import _DialogContent from "@mui/material/DialogContent";
import _CircularProgress from "@mui/material/CircularProgress";
import _Close from "@mui/icons-material/Close";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Dialog2 from "@mui/material/Dialog";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, RemoveIcon } from '../components';
import { GeogroupService } from '../services';
export function RemovePostDialog({
  Dialog: _Dialog,
  currentPartner,
  geogroup,
  newsPost,
  handleClose,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  async function handleRemove() {
    if (!geogroup || !newsPost) return;
    setLoading(true);
    try {
      await GeogroupService.removeNewsPost(geogroup.id, newsPost, currentPartner);
      handleClose(true);
      enqueueSnackbar(t('commons.news.remove_dialog.success'));
    } catch {
      enqueueSnackbar(t('commons.news.remove_dialog.server_error'), {
        variant: 'error'
      });
    }
    setLoading(false);
  }
  const Dialog = _Dialog || _Dialog2;
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: handleClose
  }, props), /*#__PURE__*/React.createElement(_DialogContent, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, t('commons.news.remove_dialog.title'))), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, t('commons.news.remove_dialog.description')), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: loading,
    onClick: () => handleClose(),
    size: "large",
    startIcon: /*#__PURE__*/React.createElement(_Close, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/React.createElement(Button, {
    color: "error",
    disabled: loading,
    onClick: handleRemove,
    size: "large",
    startIcon: loading ? /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/React.createElement(RemoveIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "outlined"
  }, t('commons.news.remove_dialog.actions.remove'))))));
}